module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-BookItalic.f00ed7a5.woff2";